module.exports = __webpack_public_path__ + "media/images/icons/video-16ac52710dcbb3acf36555f733f324c0.svg";